<div *ngIf="element" class="surveys-element-multipart-question">
    <div *ngFor="let childElement of element.data" class="multipart-child-question">
        <surveys-render-survey-element
            [element]="childElement"
            [multipartQuestionHeader]="element.label[language]"
            [multipartQuestionId]="element.id"
        ></surveys-render-survey-element>
    </div>
</div>
